// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const enum ServiceStatuses {
    Running,
    Stopped,
    Resetting,
    Stopping,
    Starting,
    Rescheduled,
    Rescheduling,
    Error
}
